function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCirle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 6.35 6.35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m3.1734 0.79375a2.3812 2.3812 0 0 0-2.3796 2.3812 2.3812 2.3812 0 0 0 2.3812 2.3812 2.3812 2.3812 0 0 0 2.3812-2.3812 2.3812 2.3812 0 0 0-2.3812-2.3812 2.3812 2.3812 0 0 0-0.0015 0zm1.337 1.2354h0.06525c0.035925 0 0.081488 0.0084 0.10131 0.0186 0.091695 0.0474 0.13784 0.16581 0.097628 0.25049-0.01125 0.023625-0.46276 0.48517-1.0103 1.0326l-0.99002 0.98992-0.58677-0.58897c-0.32272-0.32392-0.5961-0.6073-0.60749-0.6297-0.03945-0.07758-0.0177-0.16124 0.05955-0.2291 0.059475-0.0522 0.14014-0.0663 0.20123-0.03525 0.0237 0.012075 0.24367 0.22156 0.48886 0.46555l0.44581 0.44362 0.59158-0.59259c0.32537-0.32593 0.71572-0.71244 0.86745-0.85894z",
    style: {
      fill: "#87ef63",
      opacity: 0.9985,
      strokeWidth: 0.0128
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCirle);
export default __webpack_public_path__ + "static/media/check-cirle.a5685137.svg";
export { ForwardRef as ReactComponent };